class MissingAccountError extends Error {
  constructor() {
    super("User doesn't have an account");
    this.status = 400;
  }
}

export default MissingAccountError;
